module.exports = __webpack_public_path__ + "img/145.64fa4133.jpg";